import React from 'react';

export function moveBy(items, index, delta) {
  const target = index + delta;
  if (index < 0 || index >= items.length || target < 0 || target >= items.length) return items;
  const next = items.slice();
  const [item] = next.splice(index, 1);
  next.splice(target, 0, item);
  return next;
}

export function OrderControls({ label, onUp, onDown }) {
  return <span className="order-controls">
    <button type="button" aria-label={`上移${label}`} title={`上移${label}`} disabled={!onUp} onMouseDown={(event) => event.stopPropagation()} onClick={(event) => { event.stopPropagation(); onUp?.(); }}>↑</button>
    <button type="button" aria-label={`下移${label}`} title={`下移${label}`} disabled={!onDown} onMouseDown={(event) => event.stopPropagation()} onClick={(event) => { event.stopPropagation(); onDown?.(); }}>↓</button>
  </span>;
}
